import _ from 'lodash';
/**
 * @description: 退出登录逻辑
 */
export function logout() {
  const supplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
  const lang = localStorage.getItem('lang');
  if (!_.isEmpty(supplierEntity)) {
    window.open('/#/auth/login', '_self');
  } else {
    window.open('/#/auth/biellogin', '_self');
  }
  localStorage.clear();
  sessionStorage.clear();
  if (lang) localStorage.setItem('lang', lang);
}